import React from 'react';
import { InboxIcon, Loader2Icon } from 'lucide-react';
import type { ObjectType } from '../../types/offboarding';
interface PreviewPanelProps {
  accounts: number;
  leads: number;
  objects: ObjectType[];
  ownerCount: number;
  awaitingSelection: boolean;
  isRefreshing: boolean;
}
export function PreviewPanel({
  accounts,
  leads,
  objects,
  ownerCount,
  awaitingSelection,
  isRefreshing
}: PreviewPanelProps) {
  if (awaitingSelection) {
    return <div className="rounded-xl border border-dashed border-gray-300 bg-[#F9FAFB] px-5 py-6 text-center" data-id="element-266" data-mp="1nnyl4h024tc6">
        <p className="text-sm text-gray-500" data-id="element-267" data-mp="1itb0it86cj2v">
          Select at least one source owner to preview impact.
        </p>
      </div>;
  }
  if (accounts + leads === 0) {
    return <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-[#F9FAFB] px-5 py-5" role="status" data-id="element-268" data-mp="18uv7gkpl6zqq">
        <InboxIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" data-id="element-269" data-mp="zw1cszvtgjft" />
        <p className="text-sm text-gray-500" data-id="element-270" data-mp="1idwmmqauu14c">No records found for the selected source owners.</p>
      </div>;
  }
  const stats: {
    key: ObjectType;
    label: string;
    value: number;
  }[] = [{
    key: 'ACCOUNT',
    label: 'Person Accounts found',
    value: accounts
  }, {
    key: 'LEAD',
    label: 'Leads found',
    value: leads
  }];
  return <div className="rounded-xl border border-gray-200 bg-[#F9FAFB]" aria-live="polite" data-id="element-271" data-mp="1dfbqb1yq41l6">
      <dl className={`grid grid-cols-2 divide-x divide-gray-200 transition-opacity duration-150 ${isRefreshing ? 'opacity-50' : 'opacity-100'}`} data-id="element-272" data-mp="21561zg7b3k3u">
        {stats.map(stat => {
        const included = objects.includes(stat.key);
        return <div key={stat.key} className="px-5 py-4" data-id="element-273" data-mp="1w49wiy7b3pwb">
              <dt className="text-sm text-gray-600" data-id="element-274" data-mp="1w6w3owqac3e0">{stat.label}</dt>
              <dd className="mt-1 flex items-baseline gap-2" data-id="element-275" data-mp="gmpywbq8f152">
                <span className={`text-2xl font-semibold tabular-nums ${included ? 'text-gray-900' : 'text-gray-400'}`} data-id="element-276" data-mp="kqe8t12c68th">
                  {stat.value}
                </span>
                {!included && <span className="text-xs text-gray-400" data-id="element-277" data-mp="2dmgsvpxlba29">Not selected to reassign</span>}
              </dd>
            </div>;
      })}
      </dl>
      <div className="flex items-center justify-between border-t border-gray-200 px-5 py-2.5 text-xs text-gray-500" data-id="element-278" data-mp="28lkqxhwstxzh">
        <span data-id="element-279" data-mp="1zmyxustpb0kg">
          Owned by {ownerCount} source owner{ownerCount === 1 ? '' : 's'}
        </span>
        {isRefreshing && <span className="inline-flex items-center gap-1.5" data-id="element-280" data-mp="1un2w708h7l82">
            <Loader2Icon className="h-3.5 w-3.5 animate-spin" aria-hidden="true" data-id="element-281" data-mp="1posxwgrgg4i8" />
            Updating…
          </span>}
      </div>
    </div>;
}